<mat-card class="cb-margin flex-col flex">
    <mat-card-content>
        <form class="flex-row flex start-center">
            <cb-input
                label="Search"
                name="query"
                class="cb-margin-right-2x"
                [(ngModel)]="filters.query"
                (change)="refreshData()"
            ></cb-input>
            <cb-checkbox
                label="Active Only"
                name="isActive"
                [(ngModel)]="filters.isActive"
                (change)="refreshData()"
            ></cb-checkbox>
        </form>
        <cb-table
            class="flex"
            *cbWaitFor="isInitialised"
            maxHeightOffset="255"
            [loaded]="true"
            [infiniteScrollEnabled]="infiniteScrollEnabled"
            [fetch]="search()"
            [queryUpdated]="refreshData$"
            [(results)]="catalogues"
            [(currentPage)]="filters.currentPage"
        >
            <thead cbTableHead>
                <tr>
                    <td>ID</td>
                    <td>Sku</td>
                    <td>Name</td>
                    <td>UOM</td>
                    <td>Main Category</td>
                    <td>Active</td>
                    <td></td>
                </tr>
            </thead>
            <tbody cbTableBody>
                @for (catalogue of catalogues; track catalogue) {
                    <tr>
                        <td>{{ catalogue.offeringCode }}</td>
                        <td>{{ catalogue.sku }}</td>
                        <td>{{ catalogue.productName }}</td>
                        <td>{{ catalogue.uom }}</td>
                        <td>{{ catalogue.categoryPath[0].label }}</td>
                        <td>
                            <mat-icon class="cb-grey">
                                {{ catalogue.isActive ? 'check_box' : 'check_box_outline_blank' }}
                            </mat-icon>
                        </td>
                        <td cbTableShrinkCol cbTableStickyCol="end">
                            <button mat-icon-button (click)="viewCatalogueClicked(catalogue)">
                                <mat-icon>pageview</mat-icon>
                            </button>
                        </td>
                    </tr>
                }
            </tbody>
        </cb-table>
    </mat-card-content>
</mat-card>
